<div class="c-list__item focus-inwards-dark" [attr.data-test-id]="'verfahren-single-item ' + aktenzeichen">
	<div class="c-list__link list" data-test-id="set-selected-verfahren" tabindex="0" (click)="openVerfahren($event)"
	     [elementFocus]="(isSelected | async) === true" (keydown.enter)="openVerfahren()">
		<div data-test-id="aktenzeichen" class="headline">
			<schir-int-client-aktenzeichen [aktenzeichen]="verfahren.aktenzeichen" [verfahrenId]="verfahrenId"/>
		</div>
		@if (verfahren.notiz) {
			<!--		nvda sends click event on keydown; nvda switches focus on inner element by itself-->
			<div data-test-id="notiz"><span>Notiz</span>: {{ verfahren.notiz }}</div>
		}
		<div class="register-data">
			<div class="data-item">
				@if (stammdaten.schiffName) {
					<div data-test-id="schiffsname"><span>Schiffsname</span>: {{ stammdaten.schiffName }}</div>
				}
				@if (stammdaten.historischeSchiffNamen) {
					<div data-test-id="historische-schiffsnamen"><span>Historische Schiffsnamen</span>: {{ stammdaten.historischeSchiffNamen }}</div>
				}
				@if (stammdaten.unsignedSchiffName) {
					<div data-test-id="unsigned-schiffsnamen"><span>Unsignierter Schiffsname</span>: {{ stammdaten.unsignedSchiffName }}</div>
				}
				<div data-test-id="status"><span>Status</span>: {{ verfahren.status | enumToLabel: verfahrenStatusLabel }}</div>
			</div>
			<div class="data-item">
				@if (stammdaten.eigentuemerNamen) {
					<div data-test-id="eigentuemer"><span>Eigentümer</span>: {{ stammdaten.eigentuemerNamen }}</div>
				}
				@if (stammdaten.unsignedEigentuemerNamen) {
					<div data-test-id="unsigned-eigentuemer"><span>Unsignierte Eigentümer</span>: {{ stammdaten.unsignedEigentuemerNamen }}</div>
				}
				@if (stammdaten.unterscheidungssignal) {
					<div data-test-id="u-signal"><span>U-Signal</span>: {{ stammdaten.unterscheidungssignal }}</div>
				}
				@if (stammdaten.unsignedUnterscheidungssignal) {
					<div data-test-id="unsigned-u-signale"><span>Unsignierte U-Signale</span>: {{ stammdaten.unsignedUnterscheidungssignal }}</div>
				}
				@if (stammdaten.imoNummer) {
					<div data-test-id="eigentuemer-imo-nr"><span>IMO-Nr.</span>: {{ stammdaten.imoNummer }}</div>
				}
				@if (stammdaten.unsignedImoNummer) {
					<div data-test-id="unsigned-imo-nrn"><span>Unsignierte IMO-Nrn.</span>: {{ stammdaten.unsignedImoNummer }}</div>
				}
				@if (stammdaten.eintragungszeichen) {
					<div data-test-id="eintragungszeichen"><span>Eintragungszeichen</span>: {{ stammdaten.eintragungszeichen }}</div>
				}
				@if (stammdaten.unsignedEintragungszeichen) {
					<div data-test-id="unsigned-eintragungszeichen"><span>Unsigniertes Eintragungszeichen</span>: {{ stammdaten.unsignedEintragungszeichen }}</div>
				}
				@if (stammdaten.standortAkte) {
					<div data-test-id="standort-akte"><span>Standort Akte</span>: {{ stammdaten.standortAkte }}</div>
				}
				@if (stammdaten.arKennzeichen) {
					<div data-test-id="kennzeichen"><span>Kennzeichen</span>: {{ stammdaten.arKennzeichen }}</div>
				}
			</div>
		</div>
	</div>
	<schir-int-client-verfahren-single-buttons
			[verfahren]="verfahren" (openAmtlichenAuszugErstellenDialog)="openAmtlichenAuszugErstellenDialog()"
			(downloadSchiffsbrief)="downloadSchiffsbrief()" (downloadSchiffszertifikat)="downloadSchiffszertifikat()"
			(openRegisterblatt)="openRegisterBlatt()" (openNotizDialog)="openNotizDialog()"
			(markAsAbgelehnt)="markAsAbgelehnt()" (deleteVerfahren)="deleteVerfahren()"
			(assignUSignal)="openUsignalZuordnenDialog()"
	/>
</div>
